import styled, {keyframes} from "styled-components";
import React, {useState} from "react";
import {Button, Progress} from "@chakra-ui/react";

export interface WaitScreenContextI {
    setCancelCallback: (callback: () => void) => void;
    setPauseCallback: (callback: () => void) => void;
    setResumeCallback: (callback: () => void) => void;
    show: () => void;
    showProgress: (progress: number) => void;
    hide: () => void;
}

export const WaitScreenContext = React.createContext<WaitScreenContextI>({
    hide: () => null,
    setCancelCallback: () => null,
    setPauseCallback: () => null,
    setResumeCallback: () => null,
    show: () => null,
    showProgress: () => null
});

const WaitScreen = (props: any) => {
    const [isVisible, setVisible] = useState<boolean>(false);
    const [isCancelled, setCancelled] = useState<boolean>(false);
    const [progress, setProgress] = useState<number>(0);
    const [cancelCallback, setCancelCallback] = useState<() => void>(() => {
    });
    const [pauseCallback, setPauseCallback] = useState<() => void>(() => {
    });
    const [resumeCallback, setResumeCallback] = useState<() => void>(() => {
    });

    const CancelButton = () => {
        return <Button
            onMouseOver={() => {
                !isCancelled && pauseCallback ? pauseCallback() : null;
            }}
            onMouseOut={() => {
                !isCancelled && resumeCallback ? resumeCallback() : null;
            }}
            onClick={() => {
                setCancelled(true);
                cancelCallback ? cancelCallback() : null;
                doHide();
            }} variant={"danger"}>Cancel Waitscreen</Button>
    };

    const WaitComponent = () => {
        if (progress) {
            const progressString = Math.round(progress) + "%";
            return <ProgressDiv>
                <ProgressString>{progressString}</ProgressString>
                <CancelButton/>
            </ProgressDiv>;
        } else {
            return <Spinner/>;
        }
    };

    const doHide = () => {
        setVisible(false);
        setProgress(0);
        setCancelled(false);
        setCancelCallback(() => {
        });
        setPauseCallback(() => {
        });
        setResumeCallback(() => {
        });
    };

    return <WaitScreenContext.Provider value={{
        hide: doHide,
        setCancelCallback: (callbackP: () => void) => {
            setCancelCallback(() => callbackP); // The task.cancel callback from Firebase upload (Upload.tsx) is acting weird when set and called directly, so this construction is needed to avoid errors
        },
        setPauseCallback: (callbackP: () => void) => {
            setPauseCallback(() => callbackP); // The task.cancel callback from Firebase upload (Upload.tsx) is acting weird when set and called directly, so this construction is needed to avoid errors
        },
        setResumeCallback: (callbackP: () => void) => {
            setResumeCallback(() => callbackP); // The task.cancel callback from Firebase upload (Upload.tsx) is acting weird when set and called directly, so this construction is needed to avoid errors
        },
        showProgress: (progressP: number) => {
            setVisible(true);
            setProgress(progressP);
        },
        show: () => {
            setVisible(true);
        }
    }}>
        {isVisible ? <WaitScreenDiv className="waitScreen">
            <Main>
                {
                    progress ?
                        <Progress min={0} max={100} value={progress} title={`${Math.round(progress)}%`} srOnly={true}/>
                        : null
                }
                <ContentContainer>
                    <WaitComponent/>
                </ContentContainer>
            </Main>
        </WaitScreenDiv> : null}
        {props.children}
    </WaitScreenContext.Provider>
};

export default WaitScreen;


const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const Main = styled.div`
  margin: auto;
  width: 100%;
`;

const ContentContainer = styled.div`
  display: inline-block;
  position: absolute;
  width: 50%;
  right: 40px;

  top: calc(50% - 80px);
  height: 80px;
`;

const Spinner = styled.div`

  &:after {
    content: " ";
    display: block;
    width: 64px;
    height: 64px;
    margin: 8px;
    border-radius: 50%;
    border: 6px solid #fff;
    border-color: rgb(0, 100, 200) transparent rgb(0, 100, 200) transparent;
    animation: ${rotate} 1.2s linear infinite;
  }

`;

export const WaitScreenDiv = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  z-index: 2000;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.8);
`;

const ProgressDiv = styled.div`
`;

const ProgressString = styled.div`
  width: 50px;
  display: inline-block;
`;